export default {
  'matlab': {
    'title': 'CS 9A: MATLAB for Programmers',
    'schedule': {
      '1': {
        'material': [
          {
            'topic': 'Introduction to MATLAB (Part 1)',
            'reading': {
              'title': 'Mastering Matlab (1st Edition) Chapter 2',
              'type': 'text'
            }
          },
          {
            'topic': 'Introduction to MATLAB (Part 2)',
            'reading': {
              'title': 'Mastering Matlab (1st Edition) Chapter 3',
              'type': 'text'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Mastering Matlab (1st Edition) Chapter 4',
              'type': 'text'
            }
          },
          {
            'topic': 'Arrays and Array Operations (Part 1)',
            'reading': {
              'title': 'Mastering Matlab (1st Edition) Sections 5.1 - 5.7',
              'type': 'text'
            }
          }
        ],
        'assignment': null,
        'quiz': null
      },
      '2': {
        'material': [
          {
            'topic': 'Arrays and Array Operations (Part 2)',
            'reading': {
              'title': 'Mastering Matlab (1st Edition) Sections 5.8, 5.12',
              'type': 'text'
            }
          },
          {
            'topic': 'Plotting (Part 1), Vectorization, JIT-Acceleration, and Numeric Data Types',
            'reading': {
              'title': 'Mastering Matlab (1st Edition) Sections 25.1 - 25.3',
              'type': 'text'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Mastering Matlab (1st Edition) Sections 32.1 - 32.2',
              'type': 'text'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Mastering Matlab (1st Edition) Chapter 7',
              'type': 'text'
            }
          }
        ],
        'assignment': {
          'name': 'Project 1a: Correlation Coefficient',
          'template': 'correlation-coefficient'
        },
        'quiz': null
      },
      '3': {
        'material': [
          {
            'topic': 'Control Flow',
            'reading': {
              'title': 'Mastering Matlab (1st Edition) Chapter 10',
              'type': 'text'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Mastering Matlab (1st Edition) Sections 11.1 - 11.4',
              'type': 'text'
            }
          }
        ],
        'assignment': {
          'name': 'Project 1b: Generalized Dice Probabilities',
          'template': 'generalized-dice-probabilities'
        },
        'quiz': null
      },
      '4': {
        'material': [
          {
            'topic': 'Functions',
            'reading': {
              'title': 'Mastering Matlab (1st Edition) Sections 12.1 - 12.3, 12.6, 12.9 - 12.11',
              'type': 'text'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 1: Introduction to Array and Matrix Operations',
          'template': 'introduction-to-array-and-matrix-operations'
        }
      },
      '5': {
        'material': [
          {
            'topic': 'File and Directory Management',
            'reading': {
              'title': 'Mastering Matlab (1st Edition) Chapter 13',
              'type': 'text'
            }
          }
        ],
        'assignment': {
          'name': 'Project 2a: Life 1D',
          'template': 'cellular-automation'
        },
        'quiz': null
      },
      '6': {
        'material': [
          {
            'topic': 'Arrays and Array Operations (Part 3)',
            'reading': {
              'title': 'Mastering Matlab (1st Edition) Sections 5.9 - 5.11',
              'type': 'text'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Mastering Matlab (1st Edition) Chapter 6',
              'type': 'text'
            }
          }
        ],
        'assignment': {
          'name': 'Project 2b: Heat Transfer',
          'template': 'heat-transfer'
        },
        'quiz': null
      },
      '7': {
        'material': [
          {
            'topic': 'Basic Statistical Analysis and Two-Dimensional Interpolation',
            'reading': {
              'title': 'Mastering Matlab (1st Edition) Section 17.1',
              'type': 'text'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Mastering Matlab (1st Edition) Section 18.2',
              'type': 'text'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 2: Advanced Array and Matrix Operations',
          'template': 'advanced-array-and-matrix-operations'
        }
      },
      '8': {
        'material': [
          {
            'topic': 'Cell Arrays and Structures',
            'reading': {
              'title': 'Mastering Matlab (1st Edition) Chapter 8',
              'type': 'text'
            }
          },
          {
            'topic': 'Character Strings',
            'reading': {
              'title': 'Mastering Matlab (1st Edition) Chapter 9',
              'type': 'text'
            }
          }
        ],
        'assignment': null,
        'quiz': null
      },
      '9': {
        'material': [
          {
            'topic': 'Function Handles, Anonmyous Functions, Timing Functions, Plotting (Part 2) and Color and Light',
            'reading': {
              'title': 'Mastering Matlab (1st Edition) Section 12.7',
              'type': 'text'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Mastering Matlab (1st Edition) Section 15.4',
              'type': 'text'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Mastering Matlab (1st Edition) Sections 25.4 - 25.8',
              'type': 'text'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Mastering Matlab (1st Edition) Chapter 27',
              'type': 'text'
            }
          },
          {
            'topic': 'Images',
            'reading': {
              'title': 'Mastering Matlab (1st Edition) Sections 28.1 - 28.3',
              'type': 'text'
            }
          }
        ],
        'assignment': {
          'name': 'Project 3: Image Manipulation',
          'template': 'image-manipulation'
        },
        'quiz': null
      },
      '10': {
        'material': [
          {
            'topic': '',
            'reading': {
              'title': '',
              'type': 'text'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 3a: Plotting and Function Handles',
          'template': 'plotting-and-function-handles'
        }
      },
      '11': {
        'material': [
          {
            'topic': 'Symbolic Numbers, Variables, Expressions, Functions, and Matrices',
            'reading': {
              'title': 'MATLAB Documentation Create Symbolic Numbers, Variables, and Expressions',
              'type': 'url',
              'target': 'https://www.mathworks.com/help/symbolic/create-symbolic-numbers-variables-and-expressions.html'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'MATLAB Documentation Create Symbolic Functions',
              'type': 'url',
              'target': 'https://www.mathworks.com/help/symbolic/create-symbolic-functions.html'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'MATLAB Documentation Create Symbolic Matrices',
              'type': 'url',
              'target': 'https://www.mathworks.com/help/symbolic/create-symbolic-matrices.html'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': '[Reference] MATLAB Documentation Symbolic Math Toolbox',
              'type': 'url',
              'target': 'https://www.mathworks.com/help/symbolic/index.html'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 3b: Cell Arrays and Structures',
          'template': 'cell-arrays-and-structures'
        }
      },
      '12': {
        'material': [
          {
            'topic': 'Symbolic Computations',
            'reading': {
              'title': 'MATLAB Documentation Perform Symbolic Computations',
              'type': 'url',
              'target': 'https://www.mathworks.com/help/symbolic/performing-symbolic-computations.html'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'MATLAB Documentation Use Assumptions on Symbolic Variables',
              'type': 'url',
              'target': 'https://www.mathworks.com/help/symbolic/assumptions-for-symbolic-objects.html'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': '[Reference] MATLAB Documentation Symbolic Math Toolbox',
              'type': 'url',
              'target': 'https://www.mathworks.com/help/symbolic/index.html'
            }
          }
        ],
        'assignment': {
          'name': 'Project 4: Working with the Symbolic Math Toolbox',
          'template': 'working-with-the-symbolic-math-toolbox'
        },
        'quiz': null
      },
      '13': {
        'material': [
          {
            'topic': '',
            'reading': {
              'title': '',
              'type': 'text'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 4: Symbolic Math Operations',
          'template': 'symbolic-math-operations'
        }
      }
    }
  },
  'c': {
    'title': 'CS 9C: C for Programmers',
    'schedule': {
      '1': {
        'material': [
          {
            'topic': 'Introduction to Programming in C',
            'reading': {
              'title': 'Practical C Programming (3rd Edition) Chapter 1',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/c/1565923065/idot-basics/pcp3-chp-1'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Practical C Programming (3rd Edition) Sections 2.1 - 2.3',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/c/1565923065/2dot-basics-of-program-writing/pcp3-chp-2-sect-1'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Practical C Programming (3rd Edition) Chapter 3',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/c/1565923065/idot-basics/pcp3-chp-23-sect-6'
            }
          },
          {
            'topic': 'Basic Declarations and Expressions, Decision and Control Statements',
            'reading': {
              'title': 'Practical C Programming (3rd Edition) Chapter 4',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/c/1565923065/idot-basics/pcp3-chp-4'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Practical C Programming (3rd Edition) Chapter 6',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/c/1565923065/idot-basics/pcp3-chp-6'
            }
          }
        ],
        'assignment': {
          'name': 'Project 0: Setting up your environment',
          'template': 'setup'
        },
        'quiz': null
      },
      '2': {
        'material': [
          {
            'topic': 'More Control Statements, Variable Scope, and Functions',
            'reading': {
              'title': 'Practical C Programming (3rd Edition) Chapter 8',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/c/1565923065/iidot-simple-programming/pcp3-chp-8'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Practical C Programming (3rd Edition) Sections 9.1 - 9.4',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/c/1565923065/9dot-variable-scope-and-functions/pcp3-chp-9-sect-1'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Practical C Programming (3rd Edition) Appendix C',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/c/1565923065/ivdot-other-language-features/pcp3-app-c'
            }
          }
        ],
        'assignment': {
          'name': 'Project 1: Pig Latin',
          'template': 'pig-latin'
        },
        'quiz': null
      },
      '3': {
        'material': [
          {
            'topic': 'Arrays, Qualifiers, and Reading Numbers',
            'reading': {
              'title': 'Practical C Programming (3rd Edition) Chapter 5',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/c/1565923065/idot-basics/pcp3-chp-5'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 1: Fundamentals',
          'template': 'fundamentals'
        }
      },
      '4': {
        'material': [
          {
            'topic': 'Programming Process',
            'reading': {
              'title': 'Practical C Programming (3rd Edition) Chapter 7',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/c/1565923065/idot-basics/pcp3-chp-7'
            }
          },
          {
            'topic': 'Simple Pointers',
            'reading': {
              'title': 'Practical C Programming (3rd Edition) Sections 13.0 - 13.5',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/c/1565923065/iidot-simple-programming/pcp3-chp-13'
            }
          }
        ],
        'assignment': null,
        'quiz': null
      },
      '5': {
        'material': [
          {
            'topic': 'Debugging and Optimization',
            'reading': {
              'title': 'Practical C Programming (3rd Edition) Chapter 15',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/c/1565923065/iidot-simple-programming/pcp3-chp-15'
            }
          }
        ],
        'assignment': {
          'name': 'Project 2: Debugging',
          'template': 'debugging'
        },
        'quiz': null
      },
      '6': {
        'material': [
          {
            'topic': 'Recursion, C Preprocessor',
            'reading': {
              'title': 'Practical C Programming (3rd Edition) Section 9.5',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/c/1565923065/9dot-variable-scope-and-functions/pcp3-chp-9-sect-5'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Practical C Programming (3rd Edition) Chapter 10',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/c/1565923065/iidot-simple-programming/pcp3-chp-23-sect-5'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 2: Functions and Argument Pointers',
          'template': 'functions-and-argument-pointers'
        }
      },
      '7': {
        'material': [
          {
            'topic': 'Recursion, C Preprocessor, Advanced Types, Pointers and Structures, and File I/O',
            'reading': {
              'title': 'Practical C Programming (3rd Edition) Chapter 12',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/c/1565923065/iidot-simple-programming/pcp3-chp-12'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Practical C Programming (3rd Edition) Section 13.6',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/c/1565923065/13dot-simple-pointers/pcp3-chp-17-sect-1'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Practical C Programming (3rd Edition) Sections 17.1 - 17.2',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/c/1565923065/17dot-advanced-pointers/id472476'
            }
          }
        ],
        'assignment': {
          'name': 'Project 3: The "Animal" Game',
          'template': 'the-animal-game'
        },
        'quiz': null
      },
      '8': {
        'material': [
          {
            'topic': '',
            'reading': {
              'title': '',
              'type': 'text'
            }
          }
        ],
        'assignment': null,
        'quiz': null
      },
      '9': {
        'material': [
          {
            'topic': 'File Input/Output',
            'reading': {
              'title': 'Practical C Programming (3rd Edition) Chapter 14',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/c/1565923065/iidot-simple-programming/pcp3-chp-14'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 3: Arrays, Structures, and Files',
          'template': 'arrays-structures-and-files'
        }
      },
      '10': {
        'material': [
          {
            'topic': '',
            'reading': {
              'title': '',
              'type': 'text'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 4: General Use of Pointers',
          'template': 'general-use-of-pointers'
        }
      },
      '11': {
        'material': [
          {
            'topic': 'Command-Line Arguments, Advanced Pointers',
            'reading': {
              'title': 'Practical C Programming (3rd Edition) Section 13.7',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/c/1565923065/13dot-simple-pointers/pcp3-chp-13-sect-7'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Practical C Programming (3rd Edition) Sections 17.3 - 17.10',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/c/1565923065/17dot-advanced-pointers/pcp3-chp-17-sect-3'
            }
          }
        ],
        'assignment': {
          'name': 'Project 4: The "Animal" Game (revisited)',
          'template': 'the-animal-game-revisited'
        },
        'quiz': null
      },
      '12': {
        'material': [
          {
            'topic': '',
            'reading': {
              'title': '',
              'type': 'text'
            }
          }
        ],
        'assignment': null,
        'quiz': null
      },
      '13': {
        'material': [
          {
            'topic': '',
            'reading': {
              'title': '',
              'type': 'text'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 5: Linked Structures',
          'template': 'linked-structures'
        }
      }
    }
  },
  'unix': {
    'title': 'CS 9E: Productive Use of the UNIX Environment',
    'schedule': {
      '1': {
        'material': [
          {
            'topic': 'Introduction to UNIX',
            'reading': {
              'title': 'Your UNIX/LINUX: The Ultimate Guide (3rd Edition) Chapter 1',
              'type': 'text'
            }
          },
          {
            'topic': 'Basic UNIX Commands',
            'reading': {
              'title': 'Your UNIX/LINUX: The Ultimate Guide (3rd Edition) Chapter 2 (excluding Sections 2.9 and 2.15)',
              'type': 'text'
            }
          },
          {
            'topic': 'The File System',
            'reading': {
              'title': 'Your UNIX/LINUX: The Ultimate Guide (3rd Edition) Chapter 3',
              'type': 'text'
            }
          }
        ],
        'assignment': null,
        'quiz': null
      },
      '2': {
        'material': [
          {
            'topic': 'File Attributes',
            'reading': {
              'title': 'Your UNIX/LINUX: The Ultimate Guide (3rd Edition) Chapter 4',
              'type': 'text'
            }
          },
          {
            'topic': 'The Shell',
            'reading': {
              'title': 'Your UNIX/LINUX: The Ultimate Guide (3rd Edition) Chapter 6',
              'type': 'text'
            }
          }
        ],
        'assignment': {
          'name': 'Assignment 1.1: UNIX Basics',
          'template': 'unix-basics'
        },
        'quiz': null
      },
      '3': {
        'material': [
          {
            'topic': 'Customizing the Environment',
            'reading': {
              'title': 'Your UNIX/LINUX: The Ultimate Guide (3rd Edition) Chapter 8 (excluding Section 8.10)',
              'type': 'text'
            }
          },
          {
            'topic': 'Simple Filters',
            'reading': {
              'title': 'Your UNIX/LINUX: The Ultimate Guide (3rd Edition) Chapter 9',
              'type': 'text'
            }
          }
        ],
        'assignment': {
          'name': 'Assignment 1.2: The Shell and Simple Filters',
          'template': 'the-shell-and-simple-filters'
        },
        'quiz': null
      },
      '4': {
        'material': [
          {
            'topic': 'Processes',
            'reading': {
              'title': 'Your UNIX/LINUX: The Ultimate Guide (3rd Edition) Chapter 7',
              'type': 'text'
            }
          }
        ],
        'assignment': {
          'name': 'Assignment 1.3: Process Management',
          'template': 'process-management'
        },
        'quiz': null
      },
      '5': {
        'material': [
          {
            'topic': '',
            'reading': {
              'title': '',
              'type': 'text'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 1: Fundamentals',
          'template': 'fundamentals'
        }
      },
      '6': {
        'material': [
          {
            'topic': 'Looping with a List, Networking Tools',
            'reading': {
              'title': 'Your UNIX/LINUX: The Ultimate Guide (3rd Edition) Section 13.12',
              'type': 'text'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Your UNIX/LINUX: The Ultimate Guide (3rd Edition) Sections 11.1 - 11.9',
              'type': 'text'
            }
          }
        ],
        'assignment': {
          'name': 'Assignment 2: Remote Process Execution',
          'template': 'remote-process-execution'
        },
        'quiz': null
      },
      '7': {
        'material': [
          {
            'topic': '',
            'reading': {
              'title': '',
              'type': 'text'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 2: SSH',
          'template': 'ssh'
        }
      },
      '8': {
        'material': [
          {
            'topic': 'Filters Using Regular Expressions',
            'reading': {
              'title': 'Your UNIX/LINUX: The Ultimate Guide (3rd Edition) Chapter 10',
              'type': 'text'
            }
          }
        ],
        'assignment': {
          'name': 'Assignment 3: grep and sed',
          'template': 'grep-and-sed'
        },
        'quiz': null
      },
      '9': {
        'material': [
          {
            'topic': 'Introduction to Shell Programming, Special Characters',
            'reading': {
              'title': 'Advanced Bash-Scripting Guide Chapter 1',
              'type': 'url',
              'target': 'http://www.tldp.org/LDP/abs/html/why-shell.html'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Advanced Bash-Scripting Guide Chapter 2',
              'type': 'url',
              'target': 'http://www.tldp.org/LDP/abs/html/sha-bang.html'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Advanced Bash-Scripting Guide Chapter 3',
              'type': 'url',
              'target': 'http://www.tldp.org/LDP/abs/html/special-chars.html'
            }
          },
          {
            'topic': 'Variables, Parameters, Quoting, and Exiting',
            'reading': {
              'title': 'Advanced Bash-Scripting Guide Chapters 4',
              'type': 'url',
              'target': 'http://www.tldp.org/LDP/abs/html/variables.html'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Advanced Bash-Scripting Guide Chapters 5',
              'type': 'url',
              'target': 'http://www.tldp.org/LDP/abs/html/quoting.html'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Advanced Bash-Scripting Guide Chapters 6',
              'type': 'url',
              'target': 'http://www.tldp.org/LDP/abs/html/exit-status.html'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 3: grep and sed',
          'template': 'grep-and-sed'
        }
      },
      '10': {
        'material': [
          {
            'topic': 'Tests, Operations, and Process Substitution',
            'reading': {
              'title': 'Advanced Bash-Scripting Guide Chapter 7',
              'type': 'url',
              'target': 'http://www.tldp.org/LDP/abs/html/tests.html'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Advanced Bash-Scripting Guide Chapter 8',
              'type': 'url',
              'target': 'http://www.tldp.org/LDP/abs/html/operations.html'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Advanced Bash-Scripting Guide Chapter 23',
              'type': 'url',
              'target': 'http://www.tldp.org/LDP/abs/html/process-sub.html'
            }
          },
          {
            'topic': 'Another Look at Variables',
            'reading': {
              'title': 'Advanced Bash-Scripting Guide Chapter 9',
              'type': 'url',
              'target': 'http://www.tldp.org/LDP/abs/html/variables2.html'
            }
          }
        ],
        'assignment': {
          'name': 'Assignment 4.1: BASH Calculator',
          'template': 'bash-calculator'
        },
        'quiz': null
      },
      '11': {
        'material': [
          {
            'topic': 'Manipulating Variables',
            'reading': {
              'title': 'Advanced Bash-Scripting Guide Chapter 10',
              'type': 'url',
              'target': 'http://www.tldp.org/LDP/abs/html/manipulatingvars.html'
            }
          },
          {
            'topic': 'Loops and Branches',
            'reading': {
              'title': 'Advanced Bash-Scripting Guide Chapter 11',
              'type': 'url',
              'target': 'http://www.tldp.org/LDP/abs/html/loops.html'
            }
          },
          {
            'topic': 'Command Substitution, Arithmetic Expansion, Aliases, and List Constructs',
            'reading': {
              'title': 'Advanced Bash-Scripting Guide Chapter 12',
              'type': 'url',
              'target': 'http://www.tldp.org/LDP/abs/html/commandsub.html'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Advanced Bash-Scripting Guide Chapter 13',
              'type': 'url',
              'target': 'http://www.tldp.org/LDP/abs/html/arithexp.html'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Advanced Bash-Scripting Guide Chapter 25',
              'type': 'url',
              'target': 'http://www.tldp.org/LDP/abs/html/aliases.html'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Advanced Bash-Scripting Guide Chapter 26',
              'type': 'url',
              'target': 'http://www.tldp.org/LDP/abs/html/list-cons.html'
            }
          }
        ],
        'assignment': null,
        'quiz': null
      },
      '12': {
        'material': [
          {
            'topic': '/dev and /proc, Network Programming, /dev/zero, and /dev/null',
            'reading': {
              'title': 'Advanced Bash-Scripting Guide Chapter 29',
              'type': 'url',
              'target': 'http://www.tldp.org/LDP/abs/html/devproc.html'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Advanced Bash-Scripting Guide Chapter 30',
              'type': 'url',
              'target': 'http://www.tldp.org/LDP/abs/html/networkprogramming.html'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Advanced Bash-Scripting Guide Chapter 31',
              'type': 'url',
              'target': 'http://www.tldp.org/LDP/abs/html/zeros.html'
            }
          },
          {
            'topic': 'Debugging, Options, and Gotchas',
            'reading': {
              'title': 'Advanced Bash-Scripting Guide Chapter 32',
              'type': 'url',
              'target': 'http://www.tldp.org/LDP/abs/html/debugging.html'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Advanced Bash-Scripting Guide Chapter 33',
              'type': 'url',
              'target': 'http://www.tldp.org/LDP/abs/html/options.html'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Advanced Bash-Scripting Guide Chapter 34',
              'type': 'url',
              'target': 'http://www.tldp.org/LDP/abs/html/gotchas.html'
            }
          }
        ],
        'assignment': {
          'name': 'Assignment 4.2: Cat and Mouse',
          'template': 'cat-and-mouse'
        },
        'quiz': null
      },
      '13': {
        'material': [
          {
            'topic': '',
            'reading': {
              'title': '',
              'type': 'text'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 4: BASH Scripting',
          'template': 'bash-scripting'
        }
      }
    }
  },
  'cpp': {
    'title': 'CS 9F: C++ for Programmers',
    'schedule': {
      '1': {
        'material': [
          {
            'topic': 'Computer Science and Programming',
            'reading': {
              'title': 'A Computer Science Tapestry Chapter 1',
              'type': 'url',
              'target': 'http://www.cs.duke.edu/csed/tapestry/'
            }
          },
          {
            'topic': 'C++ Programs',
            'reading': {
              'title': 'A Computer Science Tapestry Chapter 2 (excluding Sections 2.4 - 2.6)',
              'type': 'url',
              'target': 'http://www.cs.duke.edu/csed/tapestry/'
            }
          }
        ],
        'assignment': {
          'name': 'Project 0: Setting up your environment',
          'template': 'setup'
        },
        'quiz': null
      },
      '2': {
        'material': [
          {
            'topic': 'Project Design and Implementation',
            'reading': {
              'title': 'A Computer Science Tapestry Chapter 3 (excluding Section 3.4)',
              'type': 'url',
              'target': 'http://www.cs.duke.edu/csed/tapestry/'
            }
          },
          {
            'topic': 'Project Control',
            'reading': {
              'title': 'A Computer Science Tapestry Chapter 4 (excluding Sections 4.5 - 4.6)',
              'type': 'url',
              'target': 'http://www.cs.duke.edu/csed/tapestry/'
            }
          }
        ],
        'assignment': null,
        'quiz': null
      },
      '3': {
        'material': [
          {
            'topic': 'Iteration with Programs',
            'reading': {
              'title': 'A Computer Science Tapestry Chapter 5 (excluding Section 5.4)',
              'type': 'url',
              'target': 'http://www.cs.duke.edu/csed/tapestry/'
            }
          }
        ],
        'assignment': {
          'name': 'Project 1a: Simple Looping and Testing',
          'template': 'simple-looping-and-testing'
        },
        'quiz': null
      },
      '4': {
        'material': [
          {
            'topic': 'Functions and Classes',
            'reading': {
              'title': 'A Computer Science Tapestry Sections 2.4 - 2.6, 3.4, 4.5 - 4.6, and 5.4',
              'type': 'url',
              'target': 'http://www.cs.duke.edu/csed/tapestry/'
            }
          },
          {
            'topic': 'Classes, Iterators, and Patterns',
            'reading': {
              'title': 'A Computer Science Tapestry Chapter 6 (excluding Sections 6.3.5, 6.3.7, and 6.5)',
              'type': 'url',
              'target': 'http://www.cs.duke.edu/csed/tapestry/'
            }
          }
        ],
        'assignment': null,
        'quiz': null
      },
      '5': {
        'material': [
          {
            'topic': 'Class Interfaces, Design, and Implementation',
            'reading': {
              'title': '\n          \n            A Computer Science Tapestry Chapter 7\n            A Computer Science Tapestry Appendix D\n          \n        ',
              'type': 'url',
              'target': 'http://www.cs.duke.edu/csed/tapestry/'
            }
          }
        ],
        'assignment': {
          'name': 'Project 1b: Flow of Control',
          'template': 'flow-of-control'
        },
        'quiz': null
      },
      '6': {
        'material': [
          {
            'topic': '',
            'reading': {
              'title': '',
              'type': 'url'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 1: Fundamentals',
          'template': 'fundamentals'
        }
      },
      '7': {
        'material': [
          {
            'topic': 'Arrays, Data, and Random Access',
            'reading': {
              'title': 'A Computer Science Tapestry Sections 8.1 - 8.3',
              'type': 'url',
              'target': 'http://www.cs.duke.edu/csed/tapestry/'
            }
          },
          {
            'topic': 'Strings and Streams',
            'reading': {
              'title': 'A Computer Science Tapestry Sections 9.1 - 9.3',
              'type': 'url',
              'target': 'http://www.cs.duke.edu/csed/tapestry/'
            }
          }
        ],
        'assignment': null,
        'quiz': null
      },
      '8': {
        'material': [
          {
            'topic': 'Sorting',
            'reading': {
              'title': 'A Computer Science Tapestry Sections 11.1 and 11.5',
              'type': 'url',
              'target': 'http://www.cs.duke.edu/csed/tapestry/'
            }
          }
        ],
        'assignment': {
          'name': 'Project 2: Vector and I/O Stream Exercises',
          'template': 'vector-and-io-stream-exercises'
        },
        'quiz': null
      },
      '9': {
        'material': [
          {
            'topic': 'Dynamic Data and Lists',
            'reading': {
              'title': 'A Computer Science Tapestry Sections 12.1 and 12.2',
              'type': 'url',
              'target': 'http://www.cs.duke.edu/csed/tapestry/'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 2: Vectors and I/O Streams',
          'template': 'vectors-and-io-streams'
        }
      },
      '10': {
        'material': [
          {
            'topic': 'Operator Overloading',
            'reading': {
              'title': 'A Computer Science Tapestry Section 9.4 and Appendix E',
              'type': 'url',
              'target': 'http://www.cs.duke.edu/csed/tapestry/'
            }
          }
        ],
        'assignment': {
          'name': 'Project 3: List Structure Exercises',
          'template': 'list-structure-exercises'
        },
        'quiz': null
      },
      '11': {
        'material': [
          {
            'topic': 'Templates',
            'reading': {
              'title': 'A Computer Science Tapestry Chapter 11',
              'type': 'url',
              'target': 'http://www.cs.duke.edu/csed/tapestry/'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 3: Dynamically Allocated Data',
          'template': 'dynamically-allocated-data'
        }
      },
      '12': {
        'material': [
          {
            'topic': 'Inheritance',
            'reading': {
              'title': 'A Computer Science Tapestry Chapter 13',
              'type': 'url',
              'target': 'http://www.cs.duke.edu/csed/tapestry/'
            }
          }
        ],
        'assignment': {
          'name': 'Project 4: Class Design Exercises',
          'template': 'class-design-exercises'
        },
        'quiz': null
      },
      '13': {
        'material': [
          {
            'topic': '',
            'reading': {
              'title': '',
              'type': 'url'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 4: Class Design',
          'template': 'class-design'
        }
      }
    }
  },
  'java': {
    'title': 'CS 9G: JAVA for Programmers',
    'schedule': {
      '1': {
        'material': [
          {
            'topic': 'Introduction to Classes, Looping, and Conditionals',
            'reading': {
              'title': 'Head First Java (2nd Edition) Chapter 1',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/java/0596009208/1dot-dive-in-a-quick-dip-breaking-the-surface/dive_in_a_quick_dip_colon_breaking_the_s'
            }
          },
          {
            'topic': 'Classes and Objects',
            'reading': {
              'title': 'Head First Java (2nd Edition) Chapter 2',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/java/0596009208/2dot-classes-and-objects-a-trip-to-objectville/classes_and_objects_colon_a_trip_to_obje'
            }
          },
          {
            'topic': 'Primitives and References',
            'reading': {
              'title': 'Head First Java (2nd Edition) Chapter 3',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/java/0596009208/3dot-primitives-and-references-know-your-variables/primitives_and_references_colon_know_you'
            }
          }
        ],
        'assignment': null,
        'quiz': null
      },
      '2': {
        'material': [
          {
            'topic': 'Methods, Encapsulation, and Instance Variables',
            'reading': {
              'title': 'Head First Java (2nd Edition) Chapter 4',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/java/0596009208/4dot-methods-use-instance-variables-how-objects-behave/methods_use_instance_variables_colon_how'
            }
          },
          {
            'topic': 'Bit Manipulation and Command-Line Arguments',
            'reading': {
              'title': 'Head First Java (2nd Edition) p. 660',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/java/0596009208/bdot-the-top-ten-topics-that-almost-made-it-into-the-real-bookdotdotdot/number_symble_10_bit_manipulation'
            }
          }
        ],
        'assignment': null,
        'quiz': null
      },
      '3': {
        'material': [
          {
            'topic': 'Introduction to Software Development, For-Loops, Operators, and Casting',
            'reading': {
              'title': 'Head First Java (2nd Edition) Chapter 5',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/java/0596009208/5dot-writing-a-program-extra-strength-methods/writing_a_program_colon_extra-strength_m'
            }
          }
        ],
        'assignment': {
          'name': 'Project 1: Cellular Automaton',
          'template': 'cellular-automaton'
        },
        'quiz': null
      },
      '4': {
        'material': [
          {
            'topic': 'The Java API',
            'reading': {
              'title': 'Head First Java (2nd Edition) Chapter 6',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/java/0596009208/6dot-get-to-know-the-java-api-using-the-java-library/get_to_know_the_java_api_colon_using_the'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 1: Fundamentals',
          'template': 'fundamentals'
        }
      },
      '5': {
        'material': [
          {
            'topic': 'The Stack and the Heap, Constructors',
            'reading': {
              'title': 'Head First Java (2nd Edition) Chapter 9 (pp. 235 - 249)',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/java/0596009208/9dot-constructors-and-garbage-collection-life-and-death-of-an-object/constructors_and_garbage_collection_colo'
            }
          }
        ],
        'assignment': {
          'name': 'Project 2: Mad Libs®',
          'template': 'mad-libs'
        },
        'quiz': null
      },
      '6': {
        'material': [],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 2: Data Structures',
          'template': 'data-structures'
        }
      },
      '7': {
        'material': [
          {
            'topic': 'Inheritance and Polymorphism',
            'reading': {
              'title': 'Head First Java (2nd Edition) Chapter 7',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/java/0596009208/7dot-inheritance-and-polymorphism-better-living-in-objectville/inheritance_and_polymorphism_colon_bette'
            }
          },
          {
            'topic': 'Interfaces and Abstract Classes',
            'reading': {
              'title': 'Head First Java (2nd Edition) Chapter 8',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/java/0596009208/8dot-interfaces-and-abstract-classes-serious-polymorphism/interfaces_and_abstract_classes_colon_se'
            }
          }
        ],
        'assignment': null,
        'quiz': null
      },
      '8': {
        'material': [
          {
            'topic': 'Constructor Chaining and Garbage Collection',
            'reading': {
              'title': 'Head First Java (2nd Edition) Chapter 9 (pp. 250 - 272)',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/java/0596009208/9dot-constructors-and-garbage-collection-life-and-death-of-an-object/wait_a_minute..._we_never_did_talk_about'
            }
          }
        ],
        'assignment': {
          'name': 'Project 3: Cat and Mouse',
          'template': 'cat-and-mouse'
        },
        'quiz': null
      },
      '9': {
        'material': [
          {
            'topic': 'Numbers and Statics',
            'reading': {
              'title': 'Head First Java (2nd Edition) Chapter 10',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/java/0596009208/10dot-numbers-and-statics-numbers-matter/numbers_and_statics_colon_numbers_matter'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 3: Advanced Objects and Classes',
          'template': 'advanced-objects-and-classes'
        }
      },
      '10': {
        'material': [
          {
            'topic': 'Exception Handling',
            'reading': {
              'title': 'Head First Java (2nd Edition) Chapter 11',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/java/0596009208/11dot-exception-handling-risky-behavior/exception_handling_colon_risky_behavior'
            }
          }
        ],
        'assignment': {
          'name': 'Project 4: Simple RPN Calculator',
          'template': 'simple-rpn-calculator'
        },
        'quiz': null
      },
      '11': {
        'material': [
          {
            'topic': 'Introduction to GUIs (Part 1)',
            'reading': {
              'title': 'Head First Java (2nd Edition) Chapter 12',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/java/0596009208/12dot-getting-gui-a-very-graphic-story/getting_gui_colon_a_very_graphic_story'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 4: Exceptions',
          'template': 'exceptions'
        }
      },
      '12': {
        'material': [
          {
            'topic': 'Introduction to GUIs (Part 2)',
            'reading': {
              'title': 'Head First Java (2nd Edition) Chapter 13',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/java/0596009208/13dot-using-swing-work-on-your-swing/using_swing_colon_work_on_your_swing'
            }
          }
        ],
        'assignment': {
          'name': 'Project 5: Cat and Mouse GUI',
          'template': 'cat-and-mouse-gui'
        },
        'quiz': null
      },
      '13': {
        'material': [],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 5: GUI Fundamentals',
          'template': 'gui-fundamentals'
        }
      }
    }
  },
  'python': {
    'title': 'CS 9H: Python for Programmers',
    'schedule': {
      '1': {
        'material': [
          {
            'topic': 'Introduction',
            'reading': {
              'title': 'Think Python (2nd Edition) Chapter 1',
              'type': 'url',
              'target': 'http://greenteapress.com/thinkpython2/html/thinkpython2002.html'
            }
          },
          {
            'topic': 'Variables, Expressions, and Statements',
            'reading': {
              'title': 'Think Python (2nd Edition) Chapter 2',
              'type': 'url',
              'target': 'http://greenteapress.com/thinkpython2/html/thinkpython2003.html'
            }
          },
          {
            'topic': 'Functions',
            'reading': {
              'title': 'Think Python (2nd Edition) Chapter 3',
              'type': 'url',
              'target': 'http://greenteapress.com/thinkpython2/html/thinkpython2004.html'
            }
          }
        ],
        'assignment': {
          'name': 'Project 0: Setting up your environment',
          'template': 'setup'
        },
        'quiz': null
      },
      '2': {
        'material': [
          {
            'topic': 'Conditionals and Recursion',
            'reading': {
              'title': 'Think Python (2nd Edition) Chapter 5',
              'type': 'url',
              'target': 'http://greenteapress.com/thinkpython2/html/thinkpython2006.html'
            }
          },
          {
            'topic': 'Fruitful Functions',
            'reading': {
              'title': 'Think Python (2nd Edition) Chapter 6',
              'type': 'url',
              'target': 'http://greenteapress.com/thinkpython2/html/thinkpython2007.html'
            }
          },
          {
            'topic': 'Iteration',
            'reading': {
              'title': 'Think Python (2nd Edition) Chapter 7',
              'type': 'url',
              'target': 'http://greenteapress.com/thinkpython2/html/thinkpython2008.html'
            }
          }
        ],
        'assignment': null,
        'quiz': null
      },
      '3': {
        'material': [
          {
            'topic': 'Strings',
            'reading': {
              'title': 'Think Python (2nd Edition) Chapter 8',
              'type': 'url',
              'target': 'http://greenteapress.com/thinkpython2/html/thinkpython2009.html'
            }
          },
          {
            'topic': 'Higher-Order Functions',
            'reading': {
              'title': 'Composing Programs 1.6',
              'type': 'url',
              'target': 'http://www.composingprograms.com/pages/16-higher-order-functions.html'
            }
          }
        ],
        'assignment': {
          'name': 'Project 1: Cellular Automaton',
          'template': 'cellular-automaton'
        },
        'quiz': null
      },
      '4': {
        'material': [
          {
            'topic': 'Lists',
            'reading': {
              'title': 'Think Python (2nd Edition) Chapter 10',
              'type': 'url',
              'target': 'http://greenteapress.com/thinkpython2/html/thinkpython2011.html'
            }
          },
          {
            'topic': 'Dictionaries',
            'reading': {
              'title': 'Think Python (2nd Edition) Chapter 11',
              'type': 'url',
              'target': 'http://greenteapress.com/thinkpython2/html/thinkpython2012.html'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 1: Expressions and Functions',
          'template': 'expressions-and-functions'
        }
      },
      '5': {
        'material': [
          {
            'topic': 'Tuples',
            'reading': {
              'title': 'Think Python (2nd Edition) Chapter 12',
              'type': 'url',
              'target': 'http://greenteapress.com/thinkpython2/html/thinkpython2013.html'
            }
          },
          {
            'topic': 'Scopes and Namespaces',
            'reading': {
              'title': 'The Python Tutorial 9.2',
              'type': 'url',
              'target': 'https://docs.python.org/3/tutorial/classes.html#python-scopes-and-namespaces'
            }
          },
          {
            'topic': 'Mutable Data',
            'reading': {
              'title': 'Composing Programs 2.4.2',
              'type': 'url',
              'target': 'http://composingprograms.com/pages/24-mutable-data.html#sequence-objects'
            }
          }
        ],
        'assignment': null,
        'quiz': null
      },
      '6': {
        'material': [
          {
            'topic': 'Files',
            'reading': {
              'title': 'Think Python (2nd Edition) Chapter 14',
              'type': 'url',
              'target': 'http://greenteapress.com/thinkpython2/html/thinkpython2015.html'
            }
          },
          {
            'topic': 'Debugging',
            'reading': {
              'title': 'Think Python (2nd Edition) Appendix A',
              'type': 'url',
              'target': 'http://greenteapress.com/thinkpython2/html/thinkpython2021.html'
            }
          }
        ],
        'assignment': {
          'name': 'Project 2: Python-Powered Unit Converter',
          'template': 'python-powered-unit-converter'
        },
        'quiz': null
      },
      '7': {
        'material': [
          {
            'topic': 'Classes and Objects',
            'reading': {
              'title': 'Think Python (2nd Edition) Chapter 15',
              'type': 'url',
              'target': 'http://greenteapress.com/thinkpython2/html/thinkpython2016.html'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 2: Collections and Mutations',
          'template': 'collections-and-mutations'
        }
      },
      '8': {
        'material': [
          {
            'topic': 'Classes and Functions',
            'reading': {
              'title': 'Think Python (2nd Edition) Chapter 16',
              'type': 'url',
              'target': 'http://greenteapress.com/thinkpython2/html/thinkpython2017.html'
            }
          },
          {
            'topic': 'Classes and Methods',
            'reading': {
              'title': 'Think Python (2nd Edition) Chapter 17',
              'type': 'url',
              'target': 'http://greenteapress.com/thinkpython2/html/thinkpython2018.html'
            }
          }
        ],
        'assignment': null,
        'quiz': null
      },
      '9': {
        'material': [
          {
            'topic': 'Generic Operations',
            'reading': {
              'title': 'Composing Programs 2.8',
              'type': 'url',
              'target': 'http://composingprograms.com/versions/v1/pages/28-generic-operations.html'
            }
          },
          {
            'topic': 'Inheritance',
            'reading': {
              'title': 'The Python Tutorial 9.5',
              'type': 'url',
              'target': 'https://docs.python.org/3/tutorial/classes.html#inheritance'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 3: Input and Output',
          'template': 'input-and-output'
        }
      },
      '10': {
        'material': [
          {
            'topic': 'Introduction to Tkinter',
            'reading': {
              'title': "An Introduction to Tkinter What's Tkinter?",
              'type': 'url',
              'target': 'http://effbot.org/tkinterbook/tkinter-whats-tkinter.htm'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'An Introduction to Tkinter Hello, Tkinter',
              'type': 'url',
              'target': 'http://effbot.org/tkinterbook/tkinter-hello-tkinter.htm'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'An Introduction to Tkinter Hello, Again',
              'type': 'url',
              'target': 'http://effbot.org/tkinterbook/tkinter-hello-again.htm'
            }
          },
          {
            'topic': 'Tkinter: The Canvas Widget',
            'reading': {
              'title': 'An Introduction to Tkinter The Tkinter Canvas Widget',
              'type': 'url',
              'target': 'http://effbot.org/tkinterbook/canvas.htm'
            }
          }
        ],
        'assignment': {
          'name': 'Project 3: Turtle Behavior',
          'template': 'turtle-behavior'
        },
        'quiz': null
      },
      '11': {
        'material': [],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 4: Object-Oriented Programming',
          'template': 'object-oriented-programming'
        }
      },
      '12': {
        'material': [
          {
            'topic': 'Graphical User Interfaces',
            'reading': {
              'title': 'Programming Python (4th Edition) Chapter 7',
              'type': 'url',
              'target': 'http://proquest.safaribooksonline.com/book/programming/python/9781449398712/iiidot-gui-programming/ch07_html'
            }
          }
        ],
        'assignment': {
          'name': 'Project 4: Turtle Arena',
          'template': 'turtle-arena'
        },
        'quiz': null
      },
      '13': {
        'material': [],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 5: Tkinter and Event-Based Programming',
          'template': 'tkinter-and-event-based-programming'
        }
      }
    }
  },
  '47b': {
    'title': 'CS 47B: Completion of Work in Computer Science 61B',
    'schedule': {
      '1': {
        'material': [
          {
            'topic': 'Iterators and Linked Lists',
            'reading': {
              'title': 'Data Structures and Problem Solving using Java (4th Edition) Sections 6.2 - 6.3',
              'type': 'text'
            }
          },
          {
            'topic': '',
            'reading': {
              'title': 'Data Structures and Problem Solving using Java (4th Edition) Sections 17.1 - 17.2, 17.5',
              'type': 'text'
            }
          },
          {
            'topic': 'Tree Traversal with Iterators',
            'reading': {
              'title': 'Data Structures and Problem Solving using Java (4th Edition) Section 18.4',
              'type': 'text'
            }
          }
        ],
        'assignment': null,
        'quiz': null
      },
      '2': {
        'material': [
          {
            'topic': 'Implementing an ArrayList with Iterators',
            'reading': {
              'title': 'Data Structures and Problem Solving using Java (4th Edition) Chapter 15',
              'type': 'text'
            }
          }
        ],
        'assignment': {
          'name': 'Project 1: Iterator Exercises',
          'template': 'iterator-exercises'
        },
        'quiz': null
      },
      '3': {
        'material': [
          {
            'topic': '',
            'reading': {
              'title': '',
              'type': 'text'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 1: Iterators',
          'template': 'iterators'
        }
      },
      '4': {
        'material': [
          {
            'topic': 'Hashing',
            'reading': {
              'title': 'Data Structures and Problem Solving using Java (4th Edition) Chapter 20',
              'type': 'text'
            }
          }
        ],
        'assignment': {
          'name': 'Project 2: Hashing Exercises',
          'template': 'hashing-exercises'
        },
        'quiz': null
      },
      '5': {
        'material': [
          {
            'topic': '',
            'reading': {
              'title': '',
              'type': 'text'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 2: Hashing',
          'template': 'hashing'
        }
      },
      '6': {
        'material': [
          {
            'topic': 'Heaps',
            'reading': {
              'title': 'Data Structures and Problem Solving using Java (4th Edition) Chapter 21',
              'type': 'text'
            }
          }
        ],
        'assignment': {
          'name': 'Project 3: Heap Exercises',
          'template': 'heap-exercises'
        },
        'quiz': null
      },
      '7': {
        'material': [
          {
            'topic': '',
            'reading': {
              'title': '',
              'type': 'text'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 3: Heaps',
          'template': 'heaps'
        }
      },
      '8': {
        'material': [
          {
            'topic': 'Graph Representations',
            'reading': {
              'title': 'Data Structures and Problem Solving using Java (4th Edition) Sections 14.1 - 14.3, 14.5',
              'type': 'text'
            }
          }
        ],
        'assignment': {
          'name': 'Project 4: Minimum Spanning Tree',
          'template': 'minimum-spanning-tree'
        },
        'quiz': null
      },
      '9': {
        'material': [
          {
            'topic': '',
            'reading': {
              'title': '',
              'type': 'text'
            }
          }
        ],
        'assignment': null,
        'quiz': {
          'name': 'Quiz 4: Graph Representations',
          'template': 'graph-representations'
        }
      },
      '10': {
        'material': [
          {
            'topic': 'Data Structure Design',
            'reading': {
              'title': 'Reference: Data Structures and Problem Solving using Java (4th Edition) Chapters 10 - 14',
              'type': 'text'
            }
          }
        ],
        'assignment': {
          'name': 'Design Project P1: Blocks',
          'template': 'blocks-project'
        },
        'quiz': {
          'name': 'Quiz 5: Data Structure Design',
          'template': 'data-structure-design'
        }
      },
      '11': {
        'material': [
          {
            'topic': '',
            'reading': {
              'title': '',
              'type': 'text'
            }
          }
        ],
        'assignment': null,
        'quiz': null
      },
      '12': {
        'material': [
          {
            'topic': '',
            'reading': {
              'title': '',
              'type': 'text'
            }
          }
        ],
        'assignment': {
          'name': 'Design Project P2: Blocks',
          'template': 'blocks-project'
        },
        'quiz': null
      },
      '13': {
        'material': [
          {
            'topic': '',
            'reading': {
              'title': '',
              'type': 'text'
            }
          }
        ],
        'assignment': null,
        'quiz': null
      },
      '14': {
        'material': [
          {
            'topic': '',
            'reading': {
              'title': '',
              'type': 'text'
            }
          }
        ],
        'assignment': {
          'name': 'Design Project P3: Blocks',
          'template': 'blocks-project'
        },
        'quiz': null
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/courses/calendar.js